import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import VueScrollTo from 'vue-scrollto'
import Home from './views/Home.vue'

const router = new Router({
    mode: 'history',
    scrollBehavior: function (to, from, savedPosition) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return {x: 0, y: 0}
        }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        }
    ]
});

Vue.use(Router)
Vue.use(VueScrollTo)
Vue.use(VueAnalytics, {
    id: 'UA-115579680-2',
    router
})

export default router;



// WEBPACK FOOTER //
// ./src/router.js